const angular = require('angular');
const app = angular.module('learn-directives');
const moment = require('moment');
/**
 * Defines the admin user assessment directive
 * @argument {Application} Application injected to gain access to the global Application functions and properties
 */
app.directive('adminUserAssessment', ['UserAssessments', function (UserAssessments) {
  return {
    restrict: 'E',
    replace: true,
    scope: {
      userAssessment: '=',
      assessment: '='
    },
    template: require('../../../templates/directives/assessments/admin-user-assessment.html'),
    controller: ['$scope', function ($scope) {
        var self = this;

        self.info = {
          loading: false,
          showIndividualScore: false,
          allowIndividualExit: false,
          activeScore: {},
          scores: [],
          user: {},
          userAssessment: {},
          parseAssessment: function(userAssessment) {
            self.info.user = userAssessment.user;
            self.info.scores = userAssessment.scores;
            self.info.userAssessment = userAssessment;
            if (userAssessment.date_passed) {
              self.info.userAssessment.formatedPassed = moment(new Date(userAssessment.date_passed)).format('D-MMM-YYYY');
            }

            self.info.allowIndividualExit = true;
            if (!self.info.scores || self.info.scores.length === 0) {
              return;
            }

            self.info.scores.forEach(function(score) {
              if (score.max_percentage || score.max_percentage === 0) {
                if (score.assessment_when_scored && (score.assessment_when_scored.percent_to_pass || score.assessment_when_scored.percent_to_pass === 0)) {
                  if (score.max_percentage >= score.assessment_when_scored.percent_to_pass) {
                    score.passed = true;
                  }
                }
              }
            });
          },
          close: function() {
            $scope.userAssessment = null;
          },
          viewScore: function(score) {
            if (score.awaiting_manual_grade) {
              return;
            }
            self.info.activeScore = score;
            self.info.showIndividualScore = true;
          },
          getRecordings: function(score) {
            var question = $scope.assessment.questions && $scope.assessment.questions[0] && $scope.assessment.questions[0].id;
            if (!question || !score || !score.graded_responses || !score.graded_responses[question] || !score.graded_responses[question].user_answer || !score.graded_responses[question].user_answer.length) {
              return 0;
            }

            return score.graded_responses[question].user_answer.length;
          }
        };

        self.initialize = function () {
          if (!$scope.userAssessment) {
            return;
          }

          self.info.userAssessment = {};
          self.info.user = {};
          self.info.activeScore = {};
          self.info.scores = [];
          self.info.showIndividualScore = false;
          self.info.allowIndividualExit = false;
          self.info.loading = true;
          UserAssessments.findOne({
            subresource: $scope.userAssessment,
            fields: '_id,company,user,assessment,in_progress_responses,scores,highest_graded_percentage,awaiting_manual_grade,passed,date_passed,createdAt,updatedAt',
            'scores-populate': 'assessment_when_scored,graded_responses,max_earned_points,max_percentage,awaiting_manual_grade,createdAt,updatedAt',
            'user-populate': 'first_name,last_name,email,full_name,image,linked_departments,linked_locations,job_title',
            'user.linked_departments-populate': 'name',
            'user.linked_locations-populate': 'name'
          }).$promise.then(function(userAssessment) {
            self.info.parseAssessment(userAssessment);
            self.info.loading = false;
          }).catch(function(error) {
            console.log('error: ', error);
            // handle error
            self.info.loading = false;
          });
        };

        $scope.$watch('userAssessment', function(newVal, oldVal) {
          if (newVal && newVal !== oldVal) {
            self.initialize();
          }
        });

        if ($scope.userAssessment) {
          self.initialize();
        }

      }],
    controllerAs: 'review'
  };
}]);